import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class EnqueteProvider {
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {}

  getEnquetes() {
    return this.http.get<any>(this.baseUrl + '/enquete/get-enquetes').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getEnquete(idEnquete) {
    return this.http
      .post<any>(this.baseUrl + '/enquete/get-enquete', {
        idEnquete: idEnquete,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  iniciarEnquete(idEnquete) {
    return this.http
      .post<any>(this.baseUrl + '/enquete/iniciar-enquete', {
        idEnquete: idEnquete,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getProximaPergunta(idEnquete) {
    return this.http
      .post<any>(this.baseUrl + '/enquete/get-proxima-pergunta', {
        idEnquete: idEnquete,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  responderPergunta(resposta) {
    return this.http.post<any>(this.baseUrl + '/enquete/responder-pergunta', resposta).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  pularPergunta(resposta) {
    return this.http.post<any>(this.baseUrl + '/enquete/pular-pergunta', resposta).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  voltarPergunta(idEnquete) {
    return this.http
      .post<any>(this.baseUrl + '/enquete/voltar-pergunta', {
        idEnquete: idEnquete,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  resumoEnquete(idEnquete) {
    return this.http
      .post<any>(this.baseUrl + '/enquete/resumo-enquete', {
        idEnquete: idEnquete,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/enquete/enquete.ts